export default {
	text: {
		abort: 'Abbrechen',
		automatic: 'Automatisch',
		autodrop: 'automatisch Sürzen',
		bib: 'StNr',
		class: 'Klasse',
		club: 'Verein',
		confirmHeatEnd: 'Bewerb wirklich beenden?',
		comment: 'Kommentar',
		deviceName: 'Gerätename',
		displayFocusWatch: 'Konzentrationsuhr anzeigen',
		drop: 'Stürzen',
		dropAfterN: 'Beste {n} nach orig. Startliste',
		editValue: 'Ergebnis bearbeiten',
		entrants: 'Athleten',
		error500: 'Server funktioniert nicht, bitte wenden Sie sich an den Administrator',
		errorLogin: 'Login fehlgeschlagen',
		errorFirstTryDrop: 'Der Start-Versuch darf nicht gestürzt werden.',
		errorResultFound: 'Für die angegebene Höhe wurden bereits Ergebnisse erfasst. Trotzdem löschen?',
		errorInvalidInput: 'Eingabe führt zu ungültigem Gesamtergebnis. Bitte kontrollieren!',
		errorMissingData: 'Keine Daten gefunden',
		errorNoServerConnection: 'Keine Verbindung zum Server',
		errorUnknowen: 'Unbekannter Fehler',
		eventOverview: 'Bewerbsübersicht',
		global: 'Global',
		height: 'Höhe',
		heightManager: 'Höhen-Editor',
		heightShort: 'm',
		hideEliminated: 'Verstecke ausgeschiedene Athleten',
		interval: 'Interval',
		jumpOff: 'Stechen',
		language: 'Sprache',
		lang: {
			'de-DE': 'Deutsch',
			'en-US': 'English (US)',
			'en-EN': 'English (UK)',
			'fr-CH': 'Français (CH)',
			'nl-NL': 'Dutch'
		},
		letIt: 'stehen lassen',
		listView: 'Listenansicht',
		loading: 'Lade...',
		login: 'Anmelden',
		logout: 'Logout',
		manual: 'Manuell',
		message: 'Nachricht',
		notStartetError: 'Bewerb nicht gestartet',
		name: 'Name',
		next: 'Nächster',
		noData: 'Keine Daten vorhanden',
		noRankingShort: 'aW',
		order: 'Reihung',
		orderIn: 'Einsortieren',
		overview: 'Übersicht',
		password: 'Passwort',
		poolMerge: 'Gruppen zusammenführen',
		poolMergeMessage: {
			request: 'Gruppen wirklich zusammenfügen?',
			errorToLessGroups: 'Zu wenig Gruppen zum Zusammenführen',
			errorAlreadyMerged: 'Die Gruppen wurden bereits zusammengeführt',
			errorResultsMissing: 'Es wurden noch nicht alle Ergebnisse erfasst',
			errorResultsMissing: 'Zusammenführung ist für diesen Bewerb nichtmöglich',
			mergeDone: 'Die Gruppen wurden auf einem anderen Endgerät zusammengeführt. Sie werden zur Bewerbsübersicht umgeleitet',
		},
		rank: 'Rang',
		ranking: 'Plätze',
		redCard: 'Rote Karte',
		refresh: 'Neu Laden',
		reset: 'Zurücksetzen',
		result: 'Ergebnis',
		resultEdit: 'Ergebniseingabe',
		save: 'Speichern',
		send: 'Senden',
		setCurrent: 'Vorlegen',
		setStartHeight: 'Starthöhe setzen',
		settings: 'Einstellungen',
		seperateClasses: 'Klassen getrennt behandeln',
		showEliminated: 'Zeige ausgeschiedene Athleten',
		startHeat: 'Bewerb starten',
		status: 'Status',
		startlist: 'Startliste',
		state: {
			can: 'abg.',
			dns: 'n.a.',
			dsq: 'disq.',
			finished: 'OK',
		},
		stopHeat: 'Bewerb beenden',
		singleHeight: "Einzelhöhe",
		toastTimeLabel: 'Anzeigedauer für Nachrichten',
		toEntrie: 'Zum Athleten',
		try: 'Versuch',
		tryAutoLogin: 'versuche Autologin',
		tryShort: 'V',
		wind: 'Wind',
		windShort: 'W',
		wkbHelp: 'WKB Hilferuf',
		yellowCard: 'Gelbe Karte',
	},
};
